export enum QuoteModeEnum {
  BASIC = "basic",
  ADVANCED = "advanced",
}
